export default __webpack_public_path__ + "static/media/colors-768w.0d54f4fe.png";